import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
token:any
settings:any
settingsForm!: FormGroup
newForm:any=false
  constructor(private loginService:LoginService,private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token');

    this.settingsForm = this.formBuilder.group({
      form: ['', Validators.required],
      port: ['', Validators.required],
      host:['', Validators.required],
         userName:['', Validators.required],
         appPassword:['', Validators.required],
    });
    this.listSettings()

  }
 
  listSettings(){
   
    this.loginService.listSettings(this.token)
    .subscribe((response: any) => {
      console.log(response.status);
      
      if (response.status === 1) {
      this.settings =response.data

      if( Object.keys(this.settings).length>0 ){

  //   this.settings= {
  //     "form": "q",
  //     "port": "q",
  //     "host": "q",
  //     "userName": "q",
  //     "appPassword": "q",
  //     "isActive": "true",
  //     "_id": "66b0d396876bbbdb69c22d96",
  //     "createdAt": "2024-08-05T13:28:54.352Z",
  //     "updatedAt": "2024-08-05T13:28:54.352Z",
  //     "__v": 0
  // },
        this.settingsForm.get('form')?.patchValue(this.settings.form);
        this.settingsForm.get('port')?.patchValue(this.settings.port);
        this.settingsForm.get('host')?.patchValue(this.settings.host);
        this.settingsForm.get('userName')?.patchValue(this.settings.userName);
     
        this.newForm = false;
       
         this.newForm=false
      }else{

        this.newForm=true

      }

      }
    else{
      this.newForm=true

    }
    
    })
console.log(this.newForm);

  }
  save(){
    console.log(this.newForm);
    
if(this.newForm){
  // this.settingsForm.value.settingId=this.settings._id
    this.loginService.addSettings(this.token,this.settingsForm.value)
    .subscribe((response: any) => {
      if (response.status === 1) {

      }})
  }
else{
  this.settingsForm.value.id=this.settings._id
  this.loginService.saveSettings(this.token,this.settingsForm.value)
  .subscribe((response: any) => {
    if (response.status === 1) {

    }})
}
}
  
}
